import { render, staticRenderFns } from "./LpuLoyaltyProgramPlate.vue?vue&type=template&id=3875b34c&"
import script from "./LpuLoyaltyProgramPlate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLoyaltyProgramPlate.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3875b34c')) {
      api.createRecord('3875b34c', component.options)
    } else {
      api.reload('3875b34c', component.options)
    }
    module.hot.accept("./LpuLoyaltyProgramPlate.vue?vue&type=template&id=3875b34c&", function () {
      api.rerender('3875b34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramPlate.vue"
export default component.exports